import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { closeNotification } from '../../../store/actions/notificationsActions';
import { compose } from 'recompose';
import Popover from '@material-ui/core/Popover';
import Dialog from '@material-ui/core/Dialog';
import { Grid, Typography } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { withRouter } from 'react-router-dom';
import { campaignStatuses } from '../../../constants';

const styles = {
  // popover: {
  //   overflow: 'visible'
  // },
  popoverContent: {
    width: '250px',
    padding: '10px',
    flexGrow: 1,
    overflow: 'visible'
  },
  campaignSelect: {
    width: '200px'
  },
  sendButton: {
    marginTop: '15px',
    marginBottom: '10px',
    color: 'white'
  },
  gridRow: {
    flexGrow: 1,
    width: '100%'
  },
  cdkGlobalScrollblock: {
    position: 'static !important',
    width: 'initial !important',
    overflowY: 'inherit !important'
  }
};

class SendCampaignMatchPopup extends Component {
  createCampaign() {
    this.props.history.push('/campaign/new');
  }

  setTargetParent = (targetParent, campaignMatchPopupTarget) => {
    if (targetParent) {
      return targetParent;
    }
    if (campaignMatchPopupTarget) {
      return campaignMatchPopupTarget.parentNode;
    }
  };

  render() {
    const {
      classes,
      open,
      campaignMatchPopupTarget,
      onClose,
      campaigns,
      campaignChangeHandler,
      campaignSelection,
      selectCampaignForProposal
    } = this.props;

    const targetParent = this.setTargetParent(
      targetParent,
      campaignMatchPopupTarget
    );

    const activeCampaigns = campaigns
      ? campaigns.filter(camp => camp.status === campaignStatuses.ACTIVE)
      : [];

    return (
      <Dialog
        id="campaign-select-popover"
        className={classes.popover}
        open={open}
        anchorEl={campaignMatchPopupTarget}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        disableRestoreFocus
      >
        {activeCampaigns && activeCampaigns.length > 0 && (
          <Grid
            container
            direction="column"
            align="center"
            justify="center"
            className={classes.popoverContent}
          >
            <Grid item xs={12} className={classes.gridRow}>
              <Typography variant="h6">Select a campaign</Typography>
            </Grid>
            <Grid item xs={12} className={classes.gridRow}>
              <TextField
                id="productCategory"
                name="productCategory"
                select
                className={classes.campaignSelect}
                SelectProps={{
                  MenuProps: {
                    className: classes.selectMenu
                  }
                }}
                margin="normal"
                variant="outlined"
                onChange={campaignChangeHandler}
                value={campaignSelection}
              >
                {activeCampaigns.map((item, i) => (
                  <MenuItem key={i} value={item}>
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} className={classes.gridRow}>
              <Button
                variant="contained"
                color="primary"
                className={classes.sendButton}
                onClick={selectCampaignForProposal}
              >
                Create Proposal
              </Button>
            </Grid>
          </Grid>
        )}
        {(!activeCampaigns || activeCampaigns.length <= 0) && (
          <Grid
            container
            direction="column"
            align="center"
            justify="center"
            className={classes.popoverContent}
          >
            <Typography variant="h6">No active campaigns</Typography>
            <Button
              variant="contained"
              color="primary"
              className={classes.sendButton}
              onClick={this.createCampaign.bind(this)}
            >
              Create Campaign
            </Button>
          </Grid>
        )}
      </Dialog>
    );
  }
}

// const mapStateToProps = state => {
//   return {
//     message: state.notifications.message,
//     open: state.notifications.open,
//     variant: state.notifications.variant
//   };
// };

const mapDispatchToProps = dispatch => {
  return {
    handlecloseNotification: () => dispatch(closeNotification())
  };
};

export default compose(
  withStyles(styles),
  connect(
    null,
    mapDispatchToProps
  ),
  withRouter
)(SendCampaignMatchPopup);



// WEBPACK FOOTER //
// ./src/components/shared/components/SendCampaignMatchPopup.js